"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7882],{

/***/ 63603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Spinner_Spinner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(17058);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Spinner/PanIcon.tsx





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 256 256"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
            href: "/logo.png",
            width: "256px"
        })
    }));
};
/* harmony default export */ var PanIcon = (Icon);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Spinner/PancakeIcon.tsx





var PancakeIcon_Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 128 128"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "128",
            height: "128",
            viewBox: "0 0 128 128",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M56.7204 37.5858C56.7204 45.3822 58.0271 54.1169 60.2906 60.8591C61.4246 64.2369 62.7705 67.0285 64.249 68.946C65.742 70.8826 67.1906 71.7103 68.5307 71.7103C71.1919 71.7103 74.4165 70.5307 77.8384 68.3524C81.235 66.1902 84.7001 63.1234 87.8127 59.5481C94.0844 52.3439 98.6784 43.3694 98.6784 35.942C98.6784 28.1653 97.1567 21.2636 93.9931 16.3543C90.8793 11.5222 86.1363 8.54284 79.3564 8.54284C72.6009 8.54284 66.9825 11.9157 63.0072 17.2564C59.0174 22.6164 56.7204 29.9263 56.7204 37.5858Z",
                    fill: "#FEDC90",
                    stroke: "#D1884F",
                    strokeWidth: "2.89134"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M32.7442 66.7859C39.4364 62.9222 47.2575 60.5211 53.8454 59.9252C57.1411 59.6272 60.0564 59.7876 62.336 60.3933C64.6294 61.0028 66.1079 62.0118 66.8368 63.2742C69.6116 68.0804 69.9429 76.4856 67.7501 84.8501C65.5656 93.1829 61.0085 100.957 54.6069 104.653C47.9434 108.5 40.9505 110.185 34.8292 109.454C28.7533 108.729 23.476 105.626 20.0729 99.7316C16.6658 93.8305 16.5364 87.5528 18.8757 81.7754C21.228 75.9659 26.1018 70.6209 32.7442 66.7859Z",
                    fill: "#D1884F",
                    stroke: "#633001",
                    strokeWidth: "2.89134"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M73.6122 7.76013C69.4145 8.86483 64.8207 11.0867 61.24 16.1556C53.2804 27.4231 51.7006 41.9592 58.5495 60.7386C65.3984 79.518 63.3431 89.9236 56.0487 98.3189C48.7543 106.714 29.475 108.685 23.3482 101.929C21.8481 100.274 17.4954 97.4588 20.3675 102.54C23.2397 107.622 30.7527 111.748 39.59 111.748C48.4273 111.748 55.5943 108.146 61.958 101.338C68.3217 94.5306 74.292 78.3883 68.3268 61.7709C60.6331 40.3385 62.8311 27.508 68.2893 19.7815C71.0879 15.8198 75.5453 12.3629 78.6077 10.5868C81.8233 8.72183 84.8797 8.42294 86.8682 8.42294C83.3332 6.65548 77.8099 6.65542 73.6122 7.76013Z",
                    fill: "#633001"
                })
            ]
        })
    }));
};
/* harmony default export */ var PancakeIcon = (PancakeIcon_Icon);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Spinner/Spinner.tsx


/* eslint-disable @typescript-eslint/no-unused-vars */ 



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	0% {\n		transform: translatey(0px);\n	}\n	50% {\n		transform: translatey(10px);\n	}\n	100% {\n		transform: translatey(0px);\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  animation: ",
        " 2s linear infinite;\n  transform: translate3d(0, 0, 0);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 6s ease-in-out infinite;\n  transform: translate3d(0, 0, 0);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var Spinner_float = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7f9a53a-0"
}).withConfig({
    componentId: "sc-e908bcc9-0"
})(_templateObject2());
var RotatingPancakeIcon = (0,styled_components_browser_esm/* default */.ZP)(PancakeIcon).withConfig({
    componentId: "sc-a7f9a53a-1"
}).withConfig({
    componentId: "sc-e908bcc9-1"
})(_templateObject3(), rotate);
var FloatingPanIcon = (0,styled_components_browser_esm/* default */.ZP)(PanIcon).withConfig({
    componentId: "sc-a7f9a53a-2"
}).withConfig({
    componentId: "sc-e908bcc9-2"
})(_templateObject4(), Spinner_float);
var Spinner = function Spinner(param) {
    var _size = param.size, size = _size === void 0 ? 128 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingPanIcon, {
            width: "".concat(size, "px")
        })
    });
};
/* harmony default export */ var Spinner_Spinner = (Spinner);


/***/ }),

/***/ 6372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11 5V16.17L6.11997 11.29C5.72997 10.9 5.08997 10.9 4.69997 11.29C4.30997 11.68 4.30997 12.31 4.69997 12.7L11.29 19.29C11.68 19.68 12.31 19.68 12.7 19.29L19.29 12.7C19.68 12.31 19.68 11.68 19.29 11.29C18.9 10.9 18.27 10.9 17.88 11.29L13 16.17V5C13 4.45 12.55 4 12 4C11.45 4 11 4.45 11 5Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 16274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13 19V7.83001L17.88 12.71C18.27 13.1 18.91 13.1 19.3 12.71C19.69 12.32 19.69 11.69 19.3 11.3L12.71 4.71001C12.32 4.32001 11.69 4.32001 11.3 4.71001L4.69997 11.29C4.30997 11.68 4.30997 12.31 4.69997 12.7C5.08997 13.09 5.71997 13.09 6.10997 12.7L11 7.83001V19C11 19.55 11.45 20 12 20C12.55 20 13 19.55 13 19Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 19527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CurrencyInputPanel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 32 modules
var src = __webpack_require__(54346);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx + 29 modules
var Box = __webpack_require__(7180);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(6260);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Metamask.tsx
var Metamask = __webpack_require__(65335);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/utils/wallet.ts + 1 modules
var wallet = __webpack_require__(84695);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(45101);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(90834);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var hooks = __webpack_require__(71900);
// EXTERNAL MODULE: ./src/components/SearchModal/CurrencySearchModal.tsx + 12 modules
var CurrencySearchModal = __webpack_require__(63439);
// EXTERNAL MODULE: ./src/components/Logo/index.ts + 2 modules
var Logo = __webpack_require__(74314);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/CurrencyInputPanel/NumericalInput.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  width: 0;\n  position: relative;\n  font-weight: 500;\n  outline: none;\n  border: none;\n  flex: 1 1 auto;\n  background-color: transparent;\n  font-size: 16px;\n  text-align: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0px;\n  -webkit-appearance: textfield;\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  [type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  ::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-1c5b2b79-0"
})(_templateObject(), function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.failure : theme.colors.text;
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "right";
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var inputRegex = RegExp("^\\d*(?:\\\\[.])?\\d*$") // match escaped "." characters via in a non-capturing group
;
var Input = /*#__PURE__*/ (0,react.memo)(function InnerInput(_param) {
    var value = _param.value, onUserInput = _param.onUserInput, placeholder = _param.placeholder, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onUserInput",
        "placeholder"
    ]);
    var enforcer = function(nextUserInput) {
        if (nextUserInput === "" || inputRegex.test((0,utils/* escapeRegExp */.hr)(nextUserInput))) {
            onUserInput(nextUserInput);
        }
    };
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        value: value,
        onChange: function(event) {
            // replace commas with periods, because we exclusively uses period as the decimal separator
            enforcer(event.target.value.replace(/,/g, "."));
        },
        // universal input options
        inputMode: "decimal",
        title: t("Token Amount"),
        autoComplete: "off",
        autoCorrect: "off",
        // text-specific options
        type: "text",
        pattern: "^[0-9]*[.,]?[0-9]*$",
        placeholder: placeholder || "0.0",
        minLength: 1,
        maxLength: 79,
        spellCheck: "false"
    }));
});

/* harmony default export */ var NumericalInput = ((/* unused pure expression or super */ null && (Input)));

// EXTERNAL MODULE: ./src/components/CopyButton/index.tsx
var CopyButton = __webpack_require__(57370);
;// CONCATENATED MODULE: ./src/components/CurrencyInputPanel/index.tsx



function CurrencyInputPanel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: ",
        ";\n"
    ]);
    CurrencyInputPanel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 8px;\n      background: ",
        ";\n      border: 1px solid ",
        ";\n      border-radius: ",
        " 8px 0px 0px;\n      height: auto;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 0.5rem;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  color: ",
        ";\n  font-size: 0.75rem;\n  line-height: 1rem;\n  padding: 0.75rem 1rem 0 1rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: column nowrap;\n  position: relative;\n  background-color: ",
        ";\n  z-index: 1;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-radius: 0px 6px 6px 16px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 6px;\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset: 0;\n  opacity: 0.6;\n  background-color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
















var InputRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3fa2fe7-0"
})(CurrencyInputPanel_templateObject(), function(param) {
    var selected = param.selected;
    return selected ? "0.75rem 0.5rem 0.75rem 1rem" : "0.75rem 0.75rem 0.75rem 1rem";
});
var CurrencySelectButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    variant: "text",
    scale: "sm"
}).withConfig({
    componentId: "sc-d3fa2fe7-1"
})(_templateObject2(), function(param) {
    var zapStyle = param.zapStyle, theme = param.theme;
    return zapStyle && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), theme.colors.background, theme.colors.cardBorder, zapStyle === "zap" ? "0px" : "8px");
});
var LabelRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3fa2fe7-2"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var InputPanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3fa2fe7-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3fa2fe7-4"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme, error = param.error;
    return theme.shadows[error ? "warning" : "inset"];
}, function(param) {
    var zapStyle = param.zapStyle;
    return !!zapStyle && (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
});
var Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3fa2fe7-5"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
function CurrencyInputPanel(param) {
    var value = param.value, onUserInput = param.onUserInput, onInputBlur = param.onInputBlur, onMax = param.onMax, showMaxButton = param.showMaxButton, label = param.label, onCurrencySelect = param.onCurrencySelect, currency = param.currency, _disableCurrencySelect = param.disableCurrencySelect, disableCurrencySelect = _disableCurrencySelect === void 0 ? false : _disableCurrencySelect, _hideBalance = param.hideBalance, hideBalance = _hideBalance === void 0 ? false : _hideBalance, zapStyle = param.zapStyle, beforeButton = param.beforeButton, _pair = param.pair, pair = _pair === void 0 ? null : _pair, otherCurrency = param.otherCurrency, id = param.id, showCommonBases = param.showCommonBases, disabled = param.disabled, error = param.error, showBUSD = param.showBUSD;
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var selectedCurrencyBalance = (0,hooks/* useCurrencyBalance */._h)(account !== null && account !== void 0 ? account : undefined, currency !== null && currency !== void 0 ? currency : undefined);
    var ref = (0,Localization/* useTranslation */.$G)(), t = ref.t, locale = ref.currentLanguage.locale;
    var token = pair ? pair.liquidityToken : (0,_instanceof/* default */.Z)(currency, src/* Token */.WU) ? currency : null;
    var tokenAddress = token ? (0,utils/* isAddress */.UJ)(token.address) : null;
    var amountInDollar = (0,useBUSDPrice/* useBUSDCurrencyAmount */.vB)(showBUSD ? currency : undefined, Number.isFinite(+value) ? +value : undefined);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySearchModal/* default */.Z, {
        onCurrencySelect: onCurrencySelect,
        selectedCurrency: currency,
        otherSelectedCurrency: otherCurrency,
        showCommonBases: showCommonBases
    })), 1), onPresentCurrencyModal = ref1[0];
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        position: "relative",
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            beforeButton,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySelectButton, {
                                zapStyle: zapStyle,
                                className: "open-currency-select-button",
                                selected: !!currency,
                                onClick: function() {
                                    if (!disableCurrencySelect) {
                                        onPresentCurrencyModal();
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        pair ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* DoubleCurrencyLogo */.ge, {
                                            currency0: pair.token0,
                                            currency1: pair.token1,
                                            size: 16,
                                            margin: true
                                        }) : currency ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                            currency: currency,
                                            size: "24px",
                                            style: {
                                                marginRight: "8px"
                                            }
                                        }) : null,
                                        pair ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            id: "pair",
                                            bold: true,
                                            children: [
                                                pair === null || pair === void 0 ? void 0 : pair.token0.symbol,
                                                ":",
                                                pair === null || pair === void 0 ? void 0 : pair.token1.symbol
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            id: "pair",
                                            bold: true,
                                            children: (currency && currency.symbol && currency.symbol.length > 20 ? "".concat(currency.symbol.slice(0, 4), "...").concat(currency.symbol.slice(currency.symbol.length - 5, currency.symbol.length)) : currency === null || currency === void 0 ? void 0 : currency.symbol) || t("Select a currency")
                                        }),
                                        !disableCurrencySelect && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {})
                                    ]
                                })
                            }),
                            token && tokenAddress ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                style: {
                                    gap: "4px"
                                },
                                ml: "4px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton/* CopyButton */.q, {
                                        width: "16px",
                                        buttonColor: "textSubtle",
                                        text: tokenAddress,
                                        tooltipMessage: t("Token address copied"),
                                        tooltipTop: -20,
                                        tooltipRight: 40,
                                        tooltipFontSize: 12
                                    }),
                                    (0,wallet/* canRegisterToken */.UO)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(Metamask/* default */.Z, {
                                        style: {
                                            cursor: "pointer"
                                        },
                                        width: "16px",
                                        onClick: function() {
                                            return (0,wallet/* registerToken */.$P)(tokenAddress, token.symbol, token.decimals, (0,_instanceof/* default */.Z)(token, types/* WrappedTokenInfo */.DT) ? token.logoURI : undefined);
                                        }
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    account && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        onClick: !disabled && onMax,
                        color: "textSubtle",
                        fontSize: "14px",
                        style: {
                            display: "inline",
                            cursor: "pointer"
                        },
                        children: !hideBalance && !!currency ? t("Balance: %balance%", {
                            balance: (ref2 = selectedCurrencyBalance === null || selectedCurrencyBalance === void 0 ? void 0 : selectedCurrencyBalance.toSignificant(6)) !== null && ref2 !== void 0 ? ref2 : t("Loading")
                        }) : " -"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputPanel, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                        as: "label",
                        zapStyle: zapStyle,
                        error: error,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelRow, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    error: error,
                                    disabled: disabled,
                                    className: "token-amount-input",
                                    value: value,
                                    onBlur: onInputBlur,
                                    onUserInput: function(val) {
                                        onUserInput(val);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputRow, {
                                selected: disableCurrencySelect,
                                children: [
                                    !!currency && showBUSD && Number.isFinite(amountInDollar) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        fontSize: "12px",
                                        color: "textSubtle",
                                        mr: "12px",
                                        children: [
                                            "~",
                                            (0,formatBalance/* formatNumber */.uf)(amountInDollar),
                                            " USD"
                                        ]
                                    }),
                                    account && currency && !disabled && showMaxButton && label !== "To" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: onMax,
                                        scale: "xs",
                                        variant: "secondary",
                                        children: t("Max").toLocaleUpperCase(locale)
                                    })
                                ]
                            })
                        ]
                    }),
                    disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 41228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ht": function() { return /* binding */ TransactionErrorContent; },
/* harmony export */   "pM": function() { return /* binding */ ConfirmationModalContent; },
/* harmony export */   "rD": function() { return /* binding */ TransactionSubmittedContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63603);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16274);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(80421);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96293);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(65335);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(7180);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(44700);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(90452);
/* harmony import */ var utils_wallet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84695);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99150);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64011);
/* harmony import */ var utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53854);
/* harmony import */ var state_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45101);
/* harmony import */ var _Layout_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39475);
/* harmony import */ var _Layout_Column__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41914);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93293);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f5a3e2b9-0"
})(_templateObject());
var Section = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_Layout_Column__WEBPACK_IMPORTED_MODULE_9__/* .AutoColumn */ .Tz).withConfig({
    componentId: "sc-f5a3e2b9-1"
})(_templateObject1());
var ConfirmedIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_Layout_Column__WEBPACK_IMPORTED_MODULE_9__/* .ColumnCenter */ .lg).withConfig({
    componentId: "sc-f5a3e2b9-2"
})(_templateObject2());
function ConfirmationPendingContent(param) {
    var pendingText = param.pendingText;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfirmedIcon, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_9__/* .AutoColumn */ .Tz, {
                gap: "12px",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        fontSize: "20px",
                        children: t("Waiting For Confirmation")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Column__WEBPACK_IMPORTED_MODULE_9__/* .AutoColumn */ .Tz, {
                        gap: "12px",
                        justify: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            bold: true,
                            small: true,
                            textAlign: "center",
                            children: pendingText
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        small: true,
                        color: "textSubtle",
                        textAlign: "center",
                        children: t("Confirm this transaction in your wallet")
                    })
                ]
            })
        ]
    });
}
function TransactionSubmittedContent(param) {
    var onDismiss = param.onDismiss, chainId = param.chainId, hash = param.hash, currencyToAdd = param.currencyToAdd;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var token = (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_6__/* .wrappedCurrency */ .pu)(currencyToAdd, chainId);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Section, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfirmedIcon, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        strokeWidth: 0.5,
                        width: "90px",
                        color: "primary"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_9__/* .AutoColumn */ .Tz, {
                    gap: "12px",
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            fontSize: "20px",
                            children: t("Transaction Submitted")
                        }),
                        chainId && hash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            external: true,
                            small: true,
                            href: (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .getBscScanLink */ .s6)(hash, "transaction", chainId),
                            children: t("View on PulseScan")
                        }),
                        currencyToAdd && (0,utils_wallet__WEBPACK_IMPORTED_MODULE_3__/* .canRegisterToken */ .UO)() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            variant: "tertiary",
                            mt: "12px",
                            width: "fit-content",
                            onClick: function() {
                                return (0,utils_wallet__WEBPACK_IMPORTED_MODULE_3__/* .registerToken */ .$P)(token.address, token.symbol, token.decimals, (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(token, state_types__WEBPACK_IMPORTED_MODULE_7__/* .WrappedTokenInfo */ .DT) ? token.logoURI : undefined);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Row__WEBPACK_IMPORTED_MODULE_8__/* .RowFixed */ .DA, {
                                children: [
                                    t("Add %asset% to Metamask", {
                                        asset: currencyToAdd.symbol
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        width: "16px",
                                        ml: "6px"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            onClick: onDismiss,
                            mt: "20px",
                            children: t("Close")
                        })
                    ]
                })
            ]
        })
    });
}
function ConfirmationModalContent(param) {
    var bottomContent = param.bottomContent, topContent = param.topContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                children: topContent()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                children: bottomContent()
            })
        ]
    });
}
function TransactionErrorContent(param) {
    var message = param.message, onDismiss = param.onDismiss;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_9__/* .AutoColumn */ .Tz, {
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        color: "failure",
                        width: "64px"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        color: "failure",
                        style: {
                            textAlign: "center",
                            width: "85%",
                            wordBreak: "break-word"
                        },
                        children: message
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                justifyContent: "center",
                pt: "24px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    onClick: onDismiss,
                    children: t("Dismiss")
                })
            })
        ]
    });
}
var TransactionConfirmationModal = function(_param) {
    var title = _param.title, onDismiss = _param.onDismiss, customOnDismiss = _param.customOnDismiss, attemptingTxn = _param.attemptingTxn, hash = _param.hash, pendingText = _param.pendingText, content = _param.content, currencyToAdd = _param.currencyToAdd, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(_param, [
        "title",
        "onDismiss",
        "customOnDismiss",
        "attemptingTxn",
        "hash",
        "pendingText",
        "content",
        "currencyToAdd"
    ]);
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().chainId;
    var handleDismiss = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (customOnDismiss) {
            customOnDismiss();
        }
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, [
        customOnDismiss,
        onDismiss
    ]);
    if (!chainId) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({
        title: title,
        headerBackground: "gradients.cardHeader"
    }, props), {
        onDismiss: handleDismiss,
        children: attemptingTxn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfirmationPendingContent, {
            pendingText: pendingText
        }) : hash ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TransactionSubmittedContent, {
            chainId: chainId,
            hash: hash,
            onDismiss: handleDismiss,
            currencyToAdd: currencyToAdd
        }) : content()
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (TransactionConfirmationModal);


/***/ }),

/***/ 19508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55855);
/* harmony import */ var _gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64011);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19838);




var useGelatoLimitOrdersLib = function() {
    var ref = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), chainId = ref.chainId, library = ref.library;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!chainId || !library) {
            console.error("Could not instantiate GelatoLimitOrders: missing chainId or library");
            return undefined;
        }
        try {
            return new _gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_1__.GelatoLimitOrders(chainId, library === null || library === void 0 ? void 0 : library.getSigner(), config_constants_exchange__WEBPACK_IMPORTED_MODULE_3__/* .GELATO_HANDLER */ .uX, false);
        } catch (error) {
            console.error("Could not instantiate GelatoLimitOrders: ".concat(error.message));
            return undefined;
        }
    }, [
        chainId,
        library
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useGelatoLimitOrdersLib);


/***/ }),

/***/ 50165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UK": function() { return /* binding */ ApprovalState; },
  "qL": function() { return /* binding */ useApproveCallback; },
  "tz": function() { return /* binding */ useApproveCallbackFromInputCurrencyAmount; },
  "re": function() { return /* binding */ useApproveCallbackFromTrade; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 32 modules
var src = __webpack_require__(54346);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(17226);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(19838);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var hooks = __webpack_require__(91001);
;// CONCATENATED MODULE: ./src/hooks/useTokenAllowance.ts




function useTokenAllowance(token, owner, spender) {
    var contract = (0,useContract/* useTokenContract */.Ib)(token === null || token === void 0 ? void 0 : token.address, false);
    var inputs = (0,react.useMemo)(function() {
        return [
            owner,
            spender
        ];
    }, [
        owner,
        spender
    ]);
    var allowance = (0,hooks/* useSingleCallResult */.Wk)(contract, "allowance", inputs).result;
    return (0,react.useMemo)(function() {
        return token && allowance ? new src/* TokenAmount */.dt(token, allowance.toString()) : undefined;
    }, [
        token,
        allowance
    ]);
}
/* harmony default export */ var hooks_useTokenAllowance = (useTokenAllowance);

// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(70193);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(55892);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 1 modules
var utils_exchange = __webpack_require__(60872);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(71228);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/hooks/limitOrders/useGelatoLimitOrdersLib.ts
var useGelatoLimitOrdersLib = __webpack_require__(19508);
;// CONCATENATED MODULE: ./src/hooks/useApproveCallback.ts



















var ApprovalState;
(function(ApprovalState) {
    ApprovalState[ApprovalState["UNKNOWN"] = 0] = "UNKNOWN";
    ApprovalState[ApprovalState["NOT_APPROVED"] = 1] = "NOT_APPROVED";
    ApprovalState[ApprovalState["PENDING"] = 2] = "PENDING";
    ApprovalState[ApprovalState["APPROVED"] = 3] = "APPROVED";
})(ApprovalState || (ApprovalState = {}));
// returns a variable indicating the state of the approval and a function which approves if necessary or early returns
function useApproveCallback(amountToApprove, spender) {
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var toastError = (0,useToast/* default */.Z)().toastError;
    var token = (0,_instanceof/* default */.Z)(amountToApprove, src/* TokenAmount */.dt) ? amountToApprove.token : undefined;
    var currentAllowance = hooks_useTokenAllowance(token, account !== null && account !== void 0 ? account : undefined, spender);
    var pendingApproval = (0,transactions_hooks/* useHasPendingApproval */.wB)(token === null || token === void 0 ? void 0 : token.address, spender);
    // check the current approval status
    var approvalState = (0,react.useMemo)(function() {
        if (!amountToApprove || !spender) return ApprovalState.UNKNOWN;
        if (amountToApprove.currency === src/* ETHER */.c0) return ApprovalState.APPROVED;
        // we might not have enough data to know whether or not we need to approve
        if (!currentAllowance) return ApprovalState.UNKNOWN;
        // amountToApprove will be defined if currentAllowance is
        return currentAllowance.lessThan(amountToApprove) ? pendingApproval ? ApprovalState.PENDING : ApprovalState.NOT_APPROVED : ApprovalState.APPROVED;
    }, [
        amountToApprove,
        currentAllowance,
        pendingApproval,
        spender
    ]);
    var tokenContract = (0,useContract/* useTokenContract */.Ib)(token === null || token === void 0 ? void 0 : token.address);
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    var approve = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var useExact, estimatedGas;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(approvalState !== ApprovalState.NOT_APPROVED)) {
                        _ctx.next = 4;
                        break;
                    }
                    toastError(t("Error"), t("Approve was called unnecessarily"));
                    console.error("approve was called unnecessarily");
                    return _ctx.abrupt("return");
                case 4:
                    if (token) {
                        _ctx.next = 8;
                        break;
                    }
                    toastError(t("Error"), t("No token"));
                    console.error("no token");
                    return _ctx.abrupt("return");
                case 8:
                    if (tokenContract) {
                        _ctx.next = 12;
                        break;
                    }
                    toastError(t("Error"), t("Cannot find contract of the token %tokenAddress%", {
                        tokenAddress: token === null || token === void 0 ? void 0 : token.address
                    }));
                    console.error("tokenContract is null");
                    return _ctx.abrupt("return");
                case 12:
                    if (amountToApprove) {
                        _ctx.next = 16;
                        break;
                    }
                    toastError(t("Error"), t("Missing amount to approve"));
                    console.error("missing amount to approve");
                    return _ctx.abrupt("return");
                case 16:
                    if (spender) {
                        _ctx.next = 20;
                        break;
                    }
                    toastError(t("Error"), t("No spender"));
                    console.error("no spender");
                    return _ctx.abrupt("return");
                case 20:
                    useExact = false;
                    _ctx.next = 23;
                    return tokenContract.estimateGas.approve(spender, bignumbers/* MaxUint256 */.Bz).catch(function() {
                        // general fallback for tokens who restrict approval amounts
                        useExact = true;
                        return tokenContract.estimateGas.approve(spender, amountToApprove.raw.toString());
                    });
                case 23:
                    estimatedGas = _ctx.sent;
                    return _ctx.abrupt("return", callWithGasPrice(tokenContract, "approve", [
                        spender,
                        useExact ? amountToApprove.raw.toString() : bignumbers/* MaxUint256 */.Bz
                    ], {
                        gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGas)
                    }).then(function(response) {
                        addTransaction(response, {
                            summary: "Approve ".concat(amountToApprove.currency.symbol),
                            approval: {
                                tokenAddress: token.address,
                                spender: spender
                            },
                            type: "approve"
                        });
                    }).catch(function(error) {
                        (0,sentry/* logError */.H)(error);
                        console.error("Failed to approve token", error);
                        if ((error === null || error === void 0 ? void 0 : error.code) !== 4001) {
                            toastError(t("Error"), error.message);
                        }
                        throw error;
                    }));
                case 25:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        approvalState,
        token,
        tokenContract,
        amountToApprove,
        spender,
        addTransaction,
        callWithGasPrice,
        t,
        toastError
    ]);
    return [
        approvalState,
        approve
    ];
}
// wraps useApproveCallback in the context of a swap
function useApproveCallbackFromTrade(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, chainId = arguments.length > 2 ? arguments[2] : void 0;
    var amountToApprove = (0,react.useMemo)(function() {
        return trade ? (0,utils_exchange/* computeSlippageAdjustedAmounts */.b5)(trade, allowedSlippage)[actions/* Field.INPUT */.gN.INPUT] : undefined;
    }, [
        trade,
        allowedSlippage
    ]);
    return useApproveCallback(amountToApprove, exchange/* ROUTER_ADDRESS */.bR[chainId]);
}
// Wraps useApproveCallback in the context of a Gelato Limit Orders
function useApproveCallbackFromInputCurrencyAmount(currencyAmountIn) {
    var gelatoLibrary = (0,useGelatoLimitOrdersLib/* default */.Z)();
    var _address;
    return useApproveCallback(currencyAmountIn, (_address = gelatoLibrary === null || gelatoLibrary === void 0 ? void 0 : gelatoLibrary.erc20OrderRouter.address) !== null && _address !== void 0 ? _address : undefined);
}


/***/ }),

/***/ 71228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useCallWithGasPrice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var state_user_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68605);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _sentry_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40802);









function useCallWithGasPrice() {
    var gasPrice = (0,state_user_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useGasPrice */ .Fh)();
    /**
   * Perform a contract call with a gas price returned from useGasPrice
   * @param contract Used to perform the call
   * @param methodName The name of the method called
   * @param methodArgs An array of arguments to pass to the method
   * @param overrides An overrides object to pass to the method. gasPrice passed in here will take priority over the price returned by useGasPrice
   * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
   */ var callWithGasPrice = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(contract, methodName) {
            var methodArgs, overrides, contractMethod, hasManualGasPriceOverride, tx, ref, _args = arguments;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        methodArgs = _args.length > 2 && _args[2] !== void 0 ? _args[2] : [], overrides = _args.length > 3 && _args[3] !== void 0 ? _args[3] : null;
                        _sentry_react__WEBPACK_IMPORTED_MODULE_5__/* .addBreadcrumb */ .n_({
                            type: "Transaction",
                            message: "Call with gas price: ".concat(gasPrice),
                            data: {
                                contractAddress: contract.address,
                                methodName: methodName,
                                methodArgs: methodArgs,
                                overrides: overrides
                            }
                        });
                        contractMethod = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(contract, methodName);
                        hasManualGasPriceOverride = overrides === null || overrides === void 0 ? void 0 : overrides.gasPrice;
                        _ctx.next = 6;
                        return contractMethod.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(methodArgs).concat([
                            hasManualGasPriceOverride ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, overrides) : (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, overrides), {
                                gasPrice: gasPrice
                            }), 
                        ]));
                    case 6:
                        tx = _ctx.sent;
                        if (tx) {
                            ;
                            _sentry_react__WEBPACK_IMPORTED_MODULE_5__/* .addBreadcrumb */ .n_({
                                type: "Transaction",
                                message: "Transaction sent: ".concat(tx.hash),
                                data: {
                                    hash: tx.hash,
                                    from: tx.from,
                                    gasLimit: (ref = tx.gasLimit) === null || ref === void 0 ? void 0 : ref.toString(),
                                    nonce: tx.nonce
                                }
                            });
                        }
                        return _ctx.abrupt("return", tx);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(contract, methodName) {
            return _ref.apply(this, arguments);
        };
    }(), [
        gasPrice
    ]);
    return {
        callWithGasPrice: callWithGasPrice
    };
}


/***/ }),

/***/ 17226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ logError; },
/* harmony export */   "Z": function() { return /* binding */ isUserRejected; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var _sentry_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40802);


var assignError = function(maybeError) {
    if (typeof maybeError === "string") {
        return new Error(maybeError);
    }
    if (typeof maybeError === "object") {
        var ref;
        var error = new Error((ref = maybeError === null || maybeError === void 0 ? void 0 : maybeError.message) !== null && ref !== void 0 ? ref : String(maybeError));
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.stack) {
            error.stack = maybeError.stack;
        }
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.code) {
            error.name = maybeError.code;
        }
        return error;
    }
    return maybeError;
};
var isUserRejected = function(err) {
    // provider user rejected error code
    return typeof err === "object" && "code" in err && err.code === 4001;
};
var ENABLED_LOG = false;
var logError = function(error) {
    if (ENABLED_LOG) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(error, Error)) {
            _sentry_react__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb(error);
        } else {
            _sentry_react__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb(assignError(error), error);
        }
    }
    console.error(error);
};


/***/ })

}]);